// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__16q8d","footer":"ModalFilter_footer__3ZxdI"};